import { makeApolloClient, logError } from '../util';
import {
	NOTIFICATION_TYPES,
	EVENT_NOTIFICATION_PREFERENCES,
} from 'queries/notificationPreferences';
import {
	SET_NOTIFICATION_TYPES,
	SET_EVENT_PREFERENCES,
	UPDATE_EVENT_PREFERENCE,
} from './actionTypes';

const setNotificationTypes = (notificationTypes, from) => ({
	type: SET_NOTIFICATION_TYPES,
	notificationTypes,
	from,
});

const setEventNotificationPreferences = (eventNotificationPreferences, from) => ({
	type: SET_EVENT_PREFERENCES,
	eventNotificationPreferences,
	from,
});

export const updateEventPreference = (eventPreference, from) => ({
	type: UPDATE_EVENT_PREFERENCE,
	eventPreference,
	from,
});

export const thunkFetchNotificationTypes = from => async (disptach, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { notificationTypes } = await client.request(NOTIFICATION_TYPES);
		disptach(setNotificationTypes(notificationTypes, from));
	} catch (error) {
		logError('np.actions.thunkFetchNotificationTypes', error);
	}
};

export const thunkFetchEventNotificationPreferences = (eventID, from) => async (
	disptach,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		const { eventNotificationPreferences } = await client.request(EVENT_NOTIFICATION_PREFERENCES, {
			event_id: eventID,
		});
		disptach(setEventNotificationPreferences(eventNotificationPreferences, from));
	} catch (error) {
		logError('np.actions.thunkFetchEventNotificationPreferences', error);
	}
};
